function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module list/todolistcheckedcommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
var attributeKey = 'todoListChecked';
/**
 * The to-do check command.
 *
 * The command is registered by the {@link module:list/todolistediting~TodoListEditing} as
 * the `'todoListCheck'` editor command.
 *
 * @extends module:core/command~Command
 */

var TodoListCheckCommand = /*#__PURE__*/function (_Command) {
  _inherits(TodoListCheckCommand, _Command);

  var _super = _createSuper(TodoListCheckCommand);

  /**
   * @inheritDoc
   */
  function TodoListCheckCommand(editor) {
    var _this;

    _classCallCheck(this, TodoListCheckCommand);

    _this = _super.call(this, editor);
    /**
     * A flag indicating whether the command is active. The command is active when at least one of
     * {@link module:engine/model/selection~Selection selected} elements is a to-do list item.
     *
     * @observable
     * @readonly
     * @member {Boolean} #isEnabled
     */

    /**
     * A list of to-do list items selected by the {@link module:engine/model/selection~Selection}.
     *
     * @observable
     * @readonly
     * @member {Array.<module:engine/model/element~Element>} #value
     */

    /**
     * A list of to-do list items selected by the {@link module:engine/model/selection~Selection}.
     *
     * @protected
     * @type {Array.<module:engine/model/element~Element>}
     */

    _this._selectedElements = []; // Refresh command before executing to be sure all values are up to date.
    // It is needed when selection has changed before command execution, in the same change block.

    _this.on('execute', function () {
      _this.refresh();
    }, {
      priority: 'highest'
    });

    return _this;
  }
  /**
   * Updates the command's {@link #value} and {@link #isEnabled} properties based on the current selection.
   */


  _createClass(TodoListCheckCommand, [{
    key: "refresh",
    value: function refresh() {
      this._selectedElements = this._getSelectedItems();
      this.value = this._selectedElements.every(function (element) {
        return !!element.getAttribute('todoListChecked');
      });
      this.isEnabled = !!this._selectedElements.length;
    }
    /**
     * Gets all to-do list items selected by the {@link module:engine/model/selection~Selection}.
     *
     * @private
     * @returns {Array.<module:engine/model/element~Element>}
     */

  }, {
    key: "_getSelectedItems",
    value: function _getSelectedItems() {
      var model = this.editor.model;
      var schema = model.schema;
      var selectionRange = model.document.selection.getFirstRange();
      var startElement = selectionRange.start.parent;
      var elements = [];

      if (schema.checkAttribute(startElement, attributeKey)) {
        elements.push(startElement);
      }

      var _iterator = _createForOfIteratorHelper(selectionRange.getItems()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (schema.checkAttribute(item, attributeKey) && !elements.includes(item)) {
            elements.push(item);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return elements;
    }
    /**
     * Executes the command.
     *
     * @param {Object} [options]
     * @param {Boolean} [options.forceValue] If set, it will force the command behavior. If `true`, the command will apply
     * the attribute. Otherwise, the command will remove the attribute. If not set, the command will look for its current
     * value to decide what it should do.
     */

  }, {
    key: "execute",
    value: function execute() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.editor.model.change(function (writer) {
        var _iterator2 = _createForOfIteratorHelper(_this2._selectedElements),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var element = _step2.value;
            var value = options.forceValue === undefined ? !_this2.value : options.forceValue;

            if (value) {
              writer.setAttribute(attributeKey, true, element);
            } else {
              writer.removeAttribute(attributeKey, element);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      });
    }
  }]);

  return TodoListCheckCommand;
}(Command);

export { TodoListCheckCommand as default };